import { logger } from '@ecosystem/newron-client-lib';
import { getAccessValueForTracking } from './access';
import { AnalyticsEvent, PlatformTrackingFunction } from './types';

export const trackAnalyticsEvent = async (event: AnalyticsEvent, platformTrackFn: PlatformTrackingFunction) => {
  const { eventName, params } = event;
  const { proposition, periodicity } = params;

  if (params.cells.length === 0 || !params.periodicity) {
    logger.warning('[useTracking/doTrack] No cells or periodicity');
    return;
  }

  // re-formatted cells use '/' instead of '-' as a separator, need to reconvert into the format understood by persona service
  const cellsWithDashes = params.cells.map(cell => cell.replace('/', '-'));

  const access = await getAccessValueForTracking(proposition, cellsWithDashes, periodicity);
  platformTrackFn(eventName, { access, ...params });
};
